import { AxiosError } from 'axios';
import { useState } from 'react';

import { BreakdownResponse } from '../../../models/dashboard/timeseries.model';
import { DateRangeOption } from '../../../models/dashboard/overview.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

/** Shared by both the "by service category" and "by provider" charts —
 * they hit sibling endpoints (`/dashboard/by-type`, `/dashboard/by-provider`)
 * with an identical request/response shape. */
const useDashboardBreakdown = (endpoint: 'by-type' | 'by-provider') => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [breakdown, setBreakdown] = useState<BreakdownResponse | null>(null);

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(err?.response?.data?.message ?? 'Failed to load breakdown');
  };

  const onSuccess = ({ data }: SuccessHttpResponse<BreakdownResponse>) => {
    setBreakdown(data);
  };

  const fetchBreakdown = (range: DateRangeOption, startDate?: string, endDate?: string) => {
    const url: HttpConfig = {
      url: `api/v1/admin/dashboard/${endpoint}`,
      method: 'get',
      params: {
        range,
        ...(range === 'custom' ? { start_date: startDate, end_date: endDate } : {}),
      },
    };

    request(url, onSuccess, setLoading, onError);
  };

  return { breakdown, loading, fetchBreakdown };
};

export default useDashboardBreakdown;
